module.exports = __webpack_public_path__ + "media/mypage/images/icons/arrow_right-e004d692eba4b20e72f9bebfe0c7fb1c.svg";